import { useInfiniteQuery } from "@tanstack/react-query";
import catalogClientAPIs from "../api/catalogClientAPIs";
 
export const useGetAllCatalogSharedData = ({ catalogId }, options = {}) => {
  return useInfiniteQuery({
    queryKey: ["catalogClientsMyBinnysData", { catalogId: catalogId }],
    queryFn: ({ pageParam = 1 }) => catalogClientAPIs.getCatalogMyBinnysData({ pageParam, queryKey: ["catalogClientsMyBinnysData", { catalogId: catalogId }] }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage < lastPage.totalPage) {
        return lastPage.nextPage + 1;
      }
      return undefined;
    },
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: true,
    enabled: options.enabled,
  });
};
 
export const useGetAllCatalogLinkData = ({ catalogId }, options = {}) => {
  return useInfiniteQuery({
    queryKey: ["catalogClientsLinkData", { catalogId: catalogId }],
    queryFn: ({ pageParam = 1 }) => catalogClientAPIs.getCatalogLinksData({ pageParam, queryKey: ["catalogClientsLinkData", { catalogId: catalogId }] }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage < lastPage.totalPage) {
        return lastPage.nextPage + 1;
      }
      return undefined;
    },
    cacheTime: 200000,
    staleTime: 200000,
    refetchOnWindowFocus: true,
    enabled: options.enabled,
  });
};